import { FieldCondition } from "./types";

/**
 * Evaluate whether a field's condition is met based on current values.
 */
export function evaluateCondition(
  condition: FieldCondition | undefined,
  values: Record<string, any>,
): boolean {
  if (!condition) return true;

  // Shorthand: string means the field key must be truthy
  if (typeof condition === "string") {
    return Boolean(values[condition]);
  }

  const { field, value, operator } = condition;
  const fieldValue = values[field];

  if (operator === "includes" && value !== undefined) {
    return typeof fieldValue === "string" && fieldValue.includes(value);
  }
  if (operator === "not_equals" && value !== undefined) {
    return fieldValue !== value;
  }
  if (operator === "equals" || value !== undefined) {
    return fieldValue === value;
  }
  // Default: truthy check
  return Boolean(fieldValue);
}

const ELEMENT_LABELS: Record<string, string> = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  h6: "H6",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell",
  carousel: "Carousel",
  "Card Container": "Card Container",
  title: "Title",
  price: "Price",
  "Retailer Icons": "Retailer Icons",
  image: "Image",
};

/**
 * Format element/group name for display
 * (e.g., "h1" -> "H1", "p" -> "Paragraph", "Carousel" -> "Carousel")
 */
export function formatElementName(name: string): string {
  return ELEMENT_LABELS[name] || name;
}
